import React, { useState } from 'react';
import { convertDateDDMMYYYY } from 'utils/dateConvertor';
import DeleteConfirmationModal from 'commonComponents/DeleteConirmationModel';
import { useDispatch, useSelector } from 'react-redux';
import { deleteRegionById } from '../redux/dispatcher';
import Tooltip from '@mui/material/Tooltip';
import { getRoleType } from 'utils/auth';

function RowData({ itemInfo, index, handleEdit, handleDelete, handleView, currentPage, rowsPerPage }) {
    const [modalOpen, setModalOpen] = useState(false);
    const dispatch = useDispatch();
    const { isLoading } = useSelector((state) => state.regionListReducer);
    const authState = useSelector((state) => state.authReducer);
    const loginUserRole = authState?.data?.user?.role || getRoleType();
    const isRegionalAdmin = loginUserRole === 'regional_admin' || loginUserRole === 'zone_admin';

    const toggleModal = () => setModalOpen(!modalOpen);

    const handleDeleteClick = () => {
        toggleModal();
    };

    const handleDeleteConfirm = () => {
        dispatch(deleteRegionById(itemInfo?.id, toggleModal));
    };

    const serialNumber = (currentPage - 1) * rowsPerPage + index + 1;

    const getAdminName = (item) => {
        let rawAdmin = item?.mapping?.regionalAdmin || item?.regionalAdmin || item?.admin;
        let adminList = [];
        if (Array.isArray(rawAdmin)) {
            adminList = rawAdmin.map(a => typeof a === 'object' ? `${a?.first_name || a?.name || ''} ${a?.last_name || ''}`.trim() : String(a)).filter(Boolean);
        } else if (typeof rawAdmin === 'object' && rawAdmin !== null) {
            const name = `${rawAdmin?.first_name || rawAdmin?.name || ''} ${rawAdmin?.last_name || ''}`.trim();
            if (name) adminList.push(name);
        } else if (typeof rawAdmin === 'string' && rawAdmin) {
            adminList.push(rawAdmin);
        } else if (item?.admin_name) {
            adminList.push(item.admin_name);
        } else if (item?.first_name) {
            adminList.push(`${item.first_name} ${item?.last_name || ''}`.trim());
        }

        if (adminList.length === 0) return '-';
        if (adminList.length === 1) return adminList[0];

        const firstAdmin = adminList[0];
        const remainingCount = adminList.length - 1;
        const hoverText = adminList.join('\n');

        return (
            <Tooltip
                title={
                    <div style={{ textAlign: 'left', padding: '4px', fontSize: '13px', lineHeight: '1.4' }}>
                        {adminList.map((adm, idx) => (
                            <div key={idx}>{adm}</div>
                        ))}
                    </div>
                }
                arrow
                placement="top"
            >
                <span
                    title={hoverText}
                    style={{
                        cursor: 'pointer',
                        color: 'rgb(14, 61, 13)',
                        fontWeight: '500'
                    }}
                >
                    {firstAdmin} + {remainingCount}
                </span>
            </Tooltip>
        );
    };

    const getCompaniesList = (item) => {
        let raw = item?.mapping?.companies || item?.companies || item?.company_names || item?.company_list || item?.companies_list || item?.company || [];
        if (typeof raw === 'string') {
            return raw.split(',').map(s => s.trim()).filter(Boolean);
        }
        if (Array.isArray(raw)) {
            return raw.map(c => {
                if (typeof c === 'string') return c;
                if (typeof c === 'object' && c !== null) {
                    return c?.company_name || c?.name || c?.title || '';
                }
                return '';
            }).filter(Boolean);
        }
        return [];
    };

    const renderCompaniesCell = (item) => {
        const companies = getCompaniesList(item);
        if (!companies || companies.length === 0) {
            return '-';
        }
        if (companies.length === 1) {
            return companies[0];
        }
        const firstCompany = companies[0];
        const remainingCount = companies.length - 1;
        const hoverText = companies.join('\n');

        return (
            <Tooltip
                title={
                    <div style={{ textAlign: 'left', padding: '4px', fontSize: '13px', lineHeight: '1.4' }}>
                        {companies.map((comp, idx) => (
                            <div key={idx}>{comp}</div>
                        ))}
                    </div>
                }
                arrow
                placement="top"
            >
                <span
                    title={hoverText}
                    style={{
                        cursor: 'pointer',
                        color: 'rgb(14, 61, 13)',
                        fontWeight: '500'
                    }}
                >
                    {firstCompany} + {remainingCount}
                </span>
            </Tooltip>
        );
    };

    return (
        <>
            <tbody>
                <tr className="align-items-center text-center">
                    <td>{itemInfo?.serial_number || serialNumber}</td>
                    <td>{itemInfo?.name || '-'}</td>
                    <td>{getAdminName(itemInfo)}</td>
                    <td>{renderCompaniesCell(itemInfo)}</td>
                    <td>{itemInfo?.address || '-'}</td>
                    <td>{itemInfo?.createdAt ? convertDateDDMMYYYY(itemInfo?.createdAt) : '-'}</td>
                    <td style={{ padding: '0px' }}>
                        <div>
                            {handleView && (
                                <i
                                    className="fa-solid fa-eye icon_hover"
                                    onClick={() => handleView(itemInfo)}
                                    style={{ marginRight: '16px', cursor: 'pointer' }}
                                    title="View"
                                ></i>
                            )}
                            <button
                                style={{ border: 'none', background: 'transparent', color: 'black', cursor: 'pointer' }}
                                onClick={() => handleEdit(itemInfo)}
                                title="Edit"
                            >
                                <i className="fa-solid fa-pen icon_hover"></i>
                            </button>
                            {!isRegionalAdmin && (
                                <i
                                    className="fa-solid fa-trash icon_hover ml-3 mr-3"
                                    onClick={handleDeleteClick}
                                    style={{ cursor: 'pointer' }}
                                    title="Delete"
                                ></i>
                            )}
                        </div>
                    </td>
                </tr>
            </tbody>
            <DeleteConfirmationModal
                isOpen={modalOpen}
                toggle={toggleModal}
                onConfirm={handleDeleteConfirm}
                itemName={`region`}
                isLoading={isLoading}
            />
        </>
    );
}

export default RowData;
